// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryDisclosureTsx from "./CanaryDisclosure.tsx";

let make = CanaryDisclosureTsx.DisclosureTableLine;

let TableLine = {
  make: make
};

let make$1 = CanaryDisclosureTsx.Disclosure;

export {
  TableLine,
  make$1 as make,
}
/* make Not a pure module */
